import ICommonText from './ICommonText';
import ICommonTextInput from './ICommonTextInput';
import * as ActionTypes from './ActionTypes';
import CommonTextsApi from './CommonTextsApi';

function createSucceeded(result: ICommonText): any {
    return { type: ActionTypes.CREATE_COMMON_TEXT_SUCCESS, result: result };
}

export function create(
    input: ICommonTextInput
): (dispatch: (result: any) => void, getState: any) => any {
    return function (dispatch: (result: any) => void, getState: any) {
        return CommonTextsApi.create(input).then((result: ICommonText) => {
            dispatch(createSucceeded(result));
        });
    };
}

function listSucceeded(result: ICommonText[]) {
    return { type: ActionTypes.LIST_COMMON_TEXT_SUCCESS, result: result };
}

export function list(): (dispatch: (result: any) => void, getState: any) => any {
    return function (dispatch: (result: any) => void, getState: any) {
        return CommonTextsApi.list().then((result: ICommonText[]) => {
            dispatch(listSucceeded(result));
        });
    };
}

function deleteSucceeded(result: number) {
    return { type: ActionTypes.DELETE_COMMON_TEXT_SUCCESS, result };
}

export function deleteCommonText(id: number) {
    return function (dispatch: (result: any) => void) {
        return CommonTextsApi.delete(id).then((result: any) => {
            dispatch(deleteSucceeded(id));
        });
    };
}
